export const OptionsList = ({ options }: { options: Array<{ name: string; origin: string }> }) => {
    if (!options?.length) return null;
    return (
        <ul>
            {options.map((option, idx) => (
                <li key={`option-${idx}`}>
                    <div className="value">
                        <strong>
                            {option.name} {option.origin}
                        </strong>
                    </div>
                </li>
            ))}
        </ul>
    );
};
